import { PermissionsScreen } from "@/screens/control-panel/permissions";

/** Thin wrapper — toda lógica fica em screens/control-panel/permissions */
export function PermissionsPage() {
  return <PermissionsScreen />;
}
